export function init(): void {
	import('./view')
		.then(mod => (new mod.CatalogItemListView(
			{root: document.getElementById('pb-main')})));
}
